import React, { useEffect ,useState} from "react";
import {Empty,Button, Pagination,Badge } from "antd";
import { useNavigate } from "react-router-dom";

import useJDStore from "../../store/jd.store";
import useStatsStore from "../../store/stats.store";

import TableDashBoard from "../TableDashBoard";

import "./teamAssignment.scss";
import Filter from "../filter";
import TeamAssignmentResumeSharing from "./teamAssignmentResumeSharing";
import TeamAssignmentNegativeFeedbacks from "./teamAssignmentNegativeFeedbacks";
import TeamAssignmentPositiveFeedbacks from "./teamAssignmentPositiveFeedbacks";
import TeamAssignmentInterviewScheduling from "./teamAssignmentInterviewScheduling";
import TeamAssignmentSelectionsAndOffers from "./teamAssignmentSelectionsAndOffers";

export default function TeamAssignmentPages(props) {

  const {teamsDashConsolidatedStats,getTeamsDashBoardConsolidatedStats,teamsDashConsolidatedStatsCount} = useStatsStore();
    
  const {teamsDashConsolidatedStatsResumesSharedCount,getTeamsDashBoardConsolidatedStatsResumesShared} = useStatsStore();
  const {teamsDashConsolidatedStatsPositiveFeedbackCount,getTeamsDashBoardConsolidatedStatsPositiveFeedbacks} = useStatsStore();
  const {teamsDashConsolidatedStatsInterviewSchedulingCount,getTeamsDashBoardConsolidatedStatsInterviewScheduling} = useStatsStore();
  const {teamsDashConsolidatedStatsNegativeFeedbackCount,getTeamsDashBoardConsolidatedStatsNegativeFeedback} = useStatsStore();
  const {teamsDashConsolidatedStatsSelectionAndOffersCount,getTeamsDashBoardConsolidatedStatsSelectionAndOffers} = useStatsStore();

  const [currentView, setCurrentView] = useState("Resume Sharing"); 

  useEffect(() => {
    
  }, []);
 
  const teamDashBoardPagesCallback = (filterDuration,encodedJsonValues ) =>{    
    getTeamsDashBoardConsolidatedStatsResumesShared(filterDuration, encodedJsonValues)    
    getTeamsDashBoardConsolidatedStatsPositiveFeedbacks(filterDuration, encodedJsonValues)
    getTeamsDashBoardConsolidatedStatsInterviewScheduling(filterDuration, encodedJsonValues)
    getTeamsDashBoardConsolidatedStatsNegativeFeedback(filterDuration, encodedJsonValues)
    getTeamsDashBoardConsolidatedStatsSelectionAndOffers(filterDuration, encodedJsonValues)
  }

  return (
    <div className="teamAssignmentPages-wrapper">     
      <div className="teamAssignmentPages-btns">
        <Badge
          count={teamsDashConsolidatedStatsResumesSharedCount}
          color="#0091ff9a"
          style={{ zIndex: 2 }}
          offset={[-5, 5]}
        >
      <Button
        onClick={() => {
            setCurrentView("Resume Sharing");
            //   navigate(`/jds/${value}`);
        }}

        className={`jd-form-option-btn ${
        currentView === "Resume Sharing" &&"jd-form-option-btn-active"
        }`}
      >
            Resume Sharing
          </Button>
        </Badge>
        <Badge
          count={
            teamsDashConsolidatedStatsPositiveFeedbackCount
          }
          color="#4f9301dd"
          style={{ zIndex: 2 }}
          offset={[-5, 5]}
        >
      <Button
        onClick={() => {
            setCurrentView("Screen/Interview Selections");
            //   navigate(`/jds/${value}`);
        }}
        className={`jd-form-option-btn ${
        currentView === "Screen/Interview Selections" &&"jd-form-option-btn-active"
        }`}
      >
            Positive Feedbacks
      </Button>    
        </Badge>
        <Badge
          count={
            teamsDashConsolidatedStatsInterviewSchedulingCount
          }
          color="#dbe51cc7"
          style={{ zIndex: 2 }}
          offset={[-5, 5]}
        >
          <Button
        onClick={() => {
            setCurrentView("Interview Scheduling/Rescheduling");
            //   navigate(`/jds/${value}`);
        }}
        className={`jd-form-option-btn ${
        currentView === "Interview Scheduling/Rescheduling" &&"jd-form-option-btn-active"
        }`}
      >
            Interview Scheduling
      </Button> 
        </Badge>
        <Badge
          count={
            teamsDashConsolidatedStatsNegativeFeedbackCount
          }
          color="#ff08009a"
          style={{ zIndex: 2 }}
          offset={[-5, 5]}
        >
      <Button
        onClick={() => {
            setCurrentView("Rejections/No Shows");
            //   navigate(`/jds/${value}`);
        }}
        className={`jd-form-option-btn ${
        currentView === "Rejections/No Shows" &&"jd-form-option-btn-active"
        }`}
      >
            Negative Feedbacks
      </Button> 
        </Badge>
        <Badge
          count={
            teamsDashConsolidatedStatsSelectionAndOffersCount
          }
          color="#00ff339a"
          style={{ zIndex: 2 }}
          offset={[-5, 5]}
        >
      <Button
        onClick={() => {
            setCurrentView("Final Selections/Offers");
            //   navigate(`/jds/${value}`);
        }}
        className={`jd-form-option-btn ${
        currentView === "Final Selections/Offers" &&"jd-form-option-btn-active"
        }`}
      >
            Final Selections/Offers
      </Button> 
        </Badge>
      </div>

      {
        currentView==="Resume Sharing"? <TeamAssignmentResumeSharing currentView={currentView} cb={teamDashBoardPagesCallback } />:
        currentView==="Screen/Interview Selections"? <TeamAssignmentPositiveFeedbacks currentView={currentView} cb={teamDashBoardPagesCallback } />:
        currentView==="Interview Scheduling/Rescheduling"? <TeamAssignmentInterviewScheduling currentView={currentView} cb={teamDashBoardPagesCallback } />:
        currentView==="Rejections/No Shows"? <TeamAssignmentNegativeFeedbacks currentView={currentView} cb={teamDashBoardPagesCallback } />:
        currentView==="Final Selections/Offers"? <TeamAssignmentSelectionsAndOffers currentView={currentView} cb={teamDashBoardPagesCallback } />:
        <></>
      }          
    </div>
  );
}
